import { render, staticRenderFns } from "./PersonDetailForm.vue?vue&type=template&id=73358945&"
import script from "./PersonDetailForm.vue?vue&type=script&lang=js&"
export * from "./PersonDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports